import React, { useEffect, useState } from 'react';
import {
  createInitiative,
  createProgram,
  createProject,
  createRisk,
  createDocument,
  createFinance,
  createDependency,
  createSla,
  createChange,
  createApproval,
  updateApproval,
  createBenefit,
  createAudit,
  createIncident,
  deleteInitiative,
  deleteProgram,
  deleteProject,
  deleteRisk,
  deleteDocument,
  deleteFinance,
  deleteDependency,
  deleteSla,
  deleteChange,
  deleteApproval,
  deleteBenefit,
  deleteAudit,
  deleteIncident,
  fetchInitiatives,
  fetchPrograms,
  fetchProjects,
  fetchRisks,
  fetchDocuments,
  fetchFinances,
  fetchDependencies,
  fetchSlas,
  fetchChanges,
  fetchApprovals,
  fetchBenefits,
  fetchAudits,
  fetchIncidents,
  updateInitiative,
  updateProgram,
  updateProject,
  updateRisk,
  updateDocument,
  updateFinance,
  updateDependency,
  updateSla,
  updateChange,
  updateBenefit,
  updateAudit,
  updateIncident,
  login,
  fetchMe,
  clearAuthToken,
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
  fetchChangeWorkflow,
  updateChangeWorkflow,
} from './api';
import './index.css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DetailsPanel from './DetailsPanel';
import { fetchAuditLogs, fetchEntity, fetchStats } from './api';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Toast from './Toast';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import BusinessIcon from '@mui/icons-material/Business';
import FlagIcon from '@mui/icons-material/Flag';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LinkIcon from '@mui/icons-material/Link';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import BugReportIcon from '@mui/icons-material/BugReport';
import HistoryIcon from '@mui/icons-material/History';
import AddIcon from '@mui/icons-material/Add';

const initialProjectForm = {
  name: '',
  sponsor: '',
  status: 'Propuesto',
  priority: 'Media',
  programId: '',
  initiativeId: '',
  startDate: '',
  endDate: '',
  progress: 0,
};

const initialProgramForm = {
  name: '',
  sponsor: '',
  objective: '',
};

const initialInitiativeForm = {
  name: '',
  origin: '',
  value: '',
  urgency: 'Media',
};

const initialRiskForm = {
  title: '',
  probability: 'Media',
  impact: 'Media',
  owner: '',
};

const initialDocumentForm = {
  title: '',
  type: 'General',
  owner: '',
  projectId: '',
};

const initialFinanceForm = {
  projectId: '',
  type: 'CAPEX',
  approved: 0,
  committed: 0,
  executed: 0,
  forecast: 0,
};

const initialDependencyForm = {
  projectId: '',
  dependsOnProjectId: '',
  type: 'Bloquea',
  owner: '',
  status: 'Activa',
  notes: '',
};

const initialSlaForm = {
  name: '',
  context: 'operacional',
  metric: '',
  target: '',
  thresholdYellow: '',
  thresholdRed: '',
  periodicity: 'Mensual',
  owner: '',
  status: 'Activo',
};

const initialChangeForm = {
  title: '',
  description: '',
  projectId: '',
  type: 'Alcance',
  impact: 'Media',
  priority: 'Media',
  status: 'Solicitado',
  approver: '',
};

const initialApprovalForm = {
  requestType: 'Proyecto',
  targetId: '',
  targetName: '',
  requestedBy: '',
  status: 'Pendiente',
  comments: '',
};

const initialBenefitForm = {
  projectId: '',
  expected: '',
  realized: '',
  status: 'Planificado',
};

const initialAuditForm = {
  title: '',
  severity: 'Media',
  owner: '',
  status: 'Abierto',
};

const initialIncidentForm = {
  title: '',
  severity: 'Media',
  description: '',
  status: 'Abierto',
};

const initialUserForm = {
  username: '',
  password: '',
  role: 'consulta',
  active: true,
};

function getErrorMessage(err, fallback) {
  return err?.message || fallback;
}

function slaComplianceColor(status) {
  if (status === 'Cumple') return 'success';
  if (status === 'En riesgo') return 'warning';
  if (status === 'Incumplido') return 'error';
  return 'default';
}

function formatSlaCurrentValue(sla) {
  if (sla.currentValue === null || sla.currentValue === undefined || Number.isNaN(Number(sla.currentValue))) {
    return '—';
  }
  const rounded = Number(sla.currentValue);
  if (sla.unit === '%') return `${rounded.toFixed(1)}%`;
  if (sla.unit === 'h') return `${rounded.toFixed(1)} h`;
  if (sla.unit === 'incidentes') return `${Math.round(rounded)} incidentes`;
  return String(rounded);
}

function toNumberOrNull(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(String(value).replace(',', '.').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : null;
}

function getSlaDirection(sla) {
  const key = String(sla.metricKey || sla.metric || '').toLowerCase();
  if (key.includes('rate') || key.includes('tasa')) return 'higher';
  return 'lower';
}

function getSlaPerformancePercent(sla) {
  const current = toNumberOrNull(sla.currentValue);
  const target = toNumberOrNull(sla.target);
  if (current === null || target === null) return null;

  const direction = getSlaDirection(sla);
  let score = null;

  if (direction === 'higher') {
    if (target <= 0) score = current > 0 ? 100 : 0;
    else score = (current / target) * 100;
  } else {
    if (current <= 0) score = 100;
    else score = (target / current) * 100;
  }

  const clamped = Math.max(0, Math.min(100, score));
  return Number.isFinite(clamped) ? clamped : null;
}

function App() {
  const [projects, setProjects] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [initiatives, setInitiatives] = useState([]);
  const [risks, setRisks] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [finances, setFinances] = useState([]);
  const [dependencies, setDependencies] = useState([]);
  const [slas, setSlas] = useState([]);
  const [changes, setChanges] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [audits, setAudits] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [users, setUsers] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditFilter, setAuditFilter] = useState('');
  const [detailView, setDetailView] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [serverStats, setServerStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [confirmDel, setConfirmDel] = useState({ open: false, label: '', onConfirm: null });
  const [formDialog, setFormDialog] = useState(null);


  const EmptyRow = ({ cols, msg = 'Sin registros' }) => (
    <TableRow>
      <TableCell colSpan={cols} align="center" sx={{ py: 4, color: 'text.disabled', fontSize: 13 }}>
        {msg}
      </TableCell>
    </TableRow>
  );

  const exportCSV = (rows, columns, filename) => {
    const header = columns.join(',');
    const body = rows.map((r) => columns.map((c) => `"${(r[c] ?? '').toString().replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };
  const openFormDialog = (type) => { cancelEdit(); setFormDialog({ type }); };
  const closeFormDialog = () => { setFormDialog(null); cancelEdit(); };
  const askDelete = (label, onConfirm) => setConfirmDel({ open: true, label, onConfirm });

  const removeToast = (id) => setToasts((t) => t.filter((x) => x.id !== id));
  const showToast = (text, type = 'info', duration = 3000) => {
    const id = String(Date.now()) + Math.random().toString(36).slice(2, 7);
    setToasts((s) => [...s, { id, text, type, duration }]);
    return id;
  };
  const [projectForm, setProjectForm] = useState(initialProjectForm);
  const [programForm, setProgramForm] = useState(initialProgramForm);
  const [initiativeForm, setInitiativeForm] = useState(initialInitiativeForm);
  const [riskForm, setRiskForm] = useState(initialRiskForm);
  const [documentForm, setDocumentForm] = useState(initialDocumentForm);
  const [financeForm, setFinanceForm] = useState(initialFinanceForm);
  const [dependencyForm, setDependencyForm] = useState(initialDependencyForm);
  const [slaForm, setSlaForm] = useState(initialSlaForm);
  const [changeForm, setChangeForm] = useState(initialChangeForm);
  const [approvalForm, setApprovalForm] = useState(initialApprovalForm);
  const [benefitForm, setBenefitForm] = useState(initialBenefitForm);
  const [auditForm, setAuditForm] = useState(initialAuditForm);
  const [incidentForm, setIncidentForm] = useState(initialIncidentForm);
  const [userForm, setUserForm] = useState(initialUserForm);
  const [editingProjectId, setEditingProjectId] = useState(null);
  const [editingProgramId, setEditingProgramId] = useState(null);
  const [editingInitiativeId, setEditingInitiativeId] = useState(null);
  const [editingRiskId, setEditingRiskId] = useState(null);
  const [editingDocumentId, setEditingDocumentId] = useState(null);
  const [editingFinanceId, setEditingFinanceId] = useState(null);
  const [editingDependencyId, setEditingDependencyId] = useState(null);
  const [editingSlaId, setEditingSlaId] = useState(null);
  const [editingChangeId, setEditingChangeId] = useState(null);
  const [editingApprovalId, setEditingApprovalId] = useState(null);
  const [editingBenefitId, setEditingBenefitId] = useState(null);
  const [editingAuditId, setEditingAuditId] = useState(null);
  const [editingIncidentId, setEditingIncidentId] = useState(null);
  const [editingUserId, setEditingUserId] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const [programFilter, setProgramFilter] = useState('');
  const [initiativeFilter, setInitiativeFilter] = useState('');
  const [changeWorkflow, setChangeWorkflow] = useState(null);
  const [changeWorkflowForm, setChangeWorkflowForm] = useState('');

  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    const bootstrapAuth = async () => {
      try {
        const me = await fetchMe();
        setCurrentUser(me);
        await loadAll(me);
      } catch (_err) {
        clearAuthToken();
      } finally {
        setAuthLoading(false);
      }
    };
    bootstrapAuth();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      await login(loginForm.username, loginForm.password);
      const me = await fetchMe();
      setCurrentUser(me);
      setLoginForm({ username: '', password: '' });
      await loadAll(me);
    } catch (err) {
      setLoginError(err.message || 'No fue posible iniciar sesión');
    }
  };

  const handleLogout = () => {
    clearAuthToken();
    setCurrentUser(null);
    setProjects([]);
    setPrograms([]);
    setInitiatives([]);
    setRisks([]);
    setDocuments([]);
    setFinances([]);
    setDependencies([]);
    setSlas([]);
    setChanges([]);
    setApprovals([]);
    setBenefits([]);
    setAudits([]);
    setIncidents([]);
    setUsers([]);
    setAuditLogs([]);
    setServerStats(null);
    setChangeWorkflow(null);
    setChangeWorkflowForm('');
  };

  const loadAll = async (authUser = currentUser) => {
    setLoading(true);
    try {
    setPrograms(await fetchPrograms());
    setInitiatives(await fetchInitiatives());
    setProjects(await fetchProjects());
    setRisks(await fetchRisks());
    setDocuments(await fetchDocuments());
    setFinances(await fetchFinances());
    setDependencies(await fetchDependencies());
    setSlas(await fetchSlas());
    setChanges(await fetchChanges());
    setApprovals(await fetchApprovals());
    setBenefits(await fetchBenefits());
    setAudits(await fetchAudits());
    setIncidents(await fetchIncidents());
    if (authUser?.permissions?.includes('workflows:read')) {
      try {
        const workflow = await fetchChangeWorkflow();
        setChangeWorkflow(workflow);
        setChangeWorkflowForm(JSON.stringify(workflow, null, 2));
      } catch (workflowErr) {
        console.error('Failed to load change workflow', workflowErr);
      }
    } else {
      setChangeWorkflow(null);
      setChangeWorkflowForm('');
    }
    try {
      setAuditLogs(await fetchAuditLogs());
    } catch (err) {
      console.error('Failed to load audit logs', err);
      showToast && showToast('Error cargando audit logs', 'error');
    }
    if (authUser?.role === 'admin') {
      try {
        setUsers(await fetchUsers());
      } catch (err) {
        console.error('Failed to load users', err);
        showToast && showToast('Error cargando usuarios', 'error');
      }
    } else {
      setUsers([]);
    }
    try { setServerStats(await fetchStats()); } catch { /* backend may be offline */ }
    } finally { setLoading(false); }
  };

  const openDetail = (type, item) => setDetailView({ type, item });
  const closeDetail = () => setDetailView(null);

  const handleSaveDetail = async (type, id, updated) => {
    // normalize type
    const t = String(type).toLowerCase();
    try {
      switch (t) {
        case 'project':
        case 'proyecto':
          await updateProject(id, updated);
          break;
        case 'program':
        case 'programa':
        case 'gerencia':
          await updateProgram(id, updated);
          break;
        case 'initiative':
        case 'iniciativa':
          await updateInitiative(id, updated);
          break;
        case 'risk':
        case 'riesgo':
          await updateRisk(id, updated);
          break;
        case 'document':
        case 'documento':
          await updateDocument(id, updated);
          break;
        case 'approval':
        case 'aprobación':
        case 'aprobacion':
          await updateApproval(id, updated);
          break;
        case 'benefit':
        case 'beneficio':
          await updateBenefit(id, updated);
          break;
        case 'audit':
        case 'auditoría':
        case 'auditoria':
          await updateAudit(id, updated);
          break;
        case 'incident':
        case 'incidente':
          await updateIncident(id, updated);
          break;
        default:
          console.warn('Unknown detail type for save:', type);
      }
    } catch (err) {
      console.error('Save detail failed', err);
      return false;
    }
    await loadAll();
    return true;
  };

  const handleProjectSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingProjectId) {
        await updateProject(editingProjectId, projectForm);
        setEditingProjectId(null);
        showToast('Proyecto actualizado', 'success');
      } else {
        await createProject(projectForm);
        showToast('Proyecto creado', 'success');
      }
      setProjectForm(initialProjectForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar proyecto'), 'error');
    }
  };

  const handleProgramSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingProgramId) {
        await updateProgram(editingProgramId, programForm);
        setEditingProgramId(null);
        showToast('Gerencia actualizada', 'success');
      } else {
        await createProgram(programForm);
        showToast('Gerencia creada', 'success');
      }
      setProgramForm(initialProgramForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar gerencia'), 'error');
    }
  };

  const handleInitiativeSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingInitiativeId) {
        await updateInitiative(editingInitiativeId, initiativeForm);
        setEditingInitiativeId(null);
        showToast('Iniciativa actualizada', 'success');
      } else {
        await createInitiative(initiativeForm);
        showToast('Iniciativa creada', 'success');
      }
      setInitiativeForm(initialInitiativeForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar iniciativa'), 'error');
    }
  };

  const handleRiskSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingRiskId) {
        await updateRisk(editingRiskId, riskForm);
        setEditingRiskId(null);
        showToast('Riesgo actualizado', 'success');
      } else {
        await createRisk(riskForm);
        showToast('Riesgo creado', 'success');
      }
      setRiskForm(initialRiskForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar riesgo'), 'error');
    }
  };

  const handleDocumentSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingDocumentId) {
        await updateDocument(editingDocumentId, documentForm);
        setEditingDocumentId(null);
        showToast('Documento actualizado', 'success');
      } else {
        await createDocument(documentForm);
        showToast('Documento creado', 'success');
      }
      setDocumentForm(initialDocumentForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar documento'), 'error');
    }
  };

  const handleFinanceSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...financeForm,
        approved: Number(financeForm.approved) || 0,
        committed: Number(financeForm.committed) || 0,
        executed: Number(financeForm.executed) || 0,
        forecast: Number(financeForm.forecast) || 0,
      };
      if (editingFinanceId) {
        await updateFinance(editingFinanceId, payload);
        setEditingFinanceId(null);
        showToast('Registro financiero actualizado', 'success');
      } else {
        await createFinance(payload);
        showToast('Registro financiero creado', 'success');
      }
      setFinanceForm(initialFinanceForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar registro financiero'), 'error');
    }
  };

  const handleDependencySubmit = async (e) => {
    e.preventDefault();
    try {
      if (!dependencyForm.projectId || !dependencyForm.dependsOnProjectId) {
        showToast('Selecciona ambos proyectos', 'error');
        return;
      }
      if (editingDependencyId) {
        await updateDependency(editingDependencyId, dependencyForm);
        setEditingDependencyId(null);
        showToast('Dependencia actualizada', 'success');
      } else {
        await createDependency(dependencyForm);
        showToast('Dependencia creada', 'success');
      }
      setDependencyForm(initialDependencyForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar dependencia'), 'error');
    }
  };

  const handleChangeSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingChangeId) {
        await updateChange(editingChangeId, changeForm);
        setEditingChangeId(null);
        showToast('Solicitud de cambio actualizada', 'success');
      } else {
        await createChange(changeForm);
        showToast('Solicitud de cambio creada', 'success');
      }
      setChangeForm(initialChangeForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar solicitud de cambio'), 'error');
    }
  };

  const handleSaveChangeWorkflow = async (e) => {
    e.preventDefault();
    try {
      const parsed = JSON.parse(changeWorkflowForm);
      const updated = await updateChangeWorkflow(parsed);
      setChangeWorkflow(updated);
      setChangeWorkflowForm(JSON.stringify(updated, null, 2));
      showToast('Flujo de cambios actualizado', 'success');
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast('El flujo de cambios debe ser JSON válido', 'error');
    }
  };

  const handleApprovalSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingApprovalId) {
        await updateApproval(editingApprovalId, approvalForm);
        setEditingApprovalId(null);
        showToast('Aprobación actualizada', 'success');
      } else {
        await createApproval(approvalForm);
        showToast('Aprobación creada', 'success');
      }
      setApprovalForm(initialApprovalForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar aprobación'), 'error');
    }
  };

  const handleBenefitSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingBenefitId) {
        await updateBenefit(editingBenefitId, benefitForm);
        setEditingBenefitId(null);
        showToast('Beneficio actualizado', 'success');

      } else {
        await createBenefit(benefitForm);
        showToast('Beneficio creado', 'success');
      }
      setBenefitForm(initialBenefitForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar beneficio'), 'error');
    }
  };

  const handleAuditSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingAuditId) {
        await updateAudit(editingAuditId, auditForm);
        setEditingAuditId(null);
        showToast('Auditoría actualizada', 'success');
      } else {
        await createAudit(auditForm);
        showToast('Auditoría creada', 'success');
      }
      setAuditForm(initialAuditForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar auditoría'), 'error');
    }
  };

  const handleIncidentSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingIncidentId) {
        await updateIncident(editingIncidentId, incidentForm);
        setEditingIncidentId(null);
        showToast('Incidente actualizado', 'success');
      } else {
        await createIncident(incidentForm);
        showToast('Incidente creado', 'success');
      }
      setIncidentForm(initialIncidentForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(getErrorMessage(err, 'Error al guardar incidente'), 'error');
    }
  };

  const handleEditChange = (changeRequest) => {
    setChangeForm({
      title: changeRequest.title,
      description: changeRequest.description,
      projectId: changeRequest.projectId || '',
      type: changeRequest.type,
      impact: changeRequest.impact,
      priority: changeRequest.priority,
      status: changeRequest.status || 'Solicitado',
      approver: changeRequest.approver || '',
    });
    setEditingChangeId(changeRequest.id);
    setFormDialog({ type: 'change' });
  };

  const handleDeleteChange = (id) => askDelete('esta solicitud de cambio', () => _doDelete(() => deleteChange(id), 'Solicitud de cambio'));

  const handleEditDependency = (dependency) => {
    setDependencyForm({
      projectId: dependency.projectId || '',
      dependsOnProjectId: dependency.dependsOnProjectId || '',
      type: dependency.type || 'Bloquea',
      owner: dependency.owner || '',
      status: dependency.status || 'Activa',
      notes: dependency.notes || '',
    });
    setEditingDependencyId(dependency.id);
    setFormDialog({ type: 'dependency' });
  };

  const handleDeleteDependency = (id) => askDelete('esta dependencia', () => _doDelete(() => deleteDependency(id), 'Dependencia'));

  const handleSlaSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!slaForm.name) {
        showToast('El SLA requiere un nombre', 'error');
        return;
      }
      if (editingSlaId) {
        await updateSla(editingSlaId, slaForm);
        setEditingSlaId(null);
        showToast('SLA actualizado', 'success');
      } else {
        await createSla(slaForm);
        showToast('SLA creado', 'success');
      }
      setSlaForm(initialSlaForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(err.message || 'Error al guardar SLA', 'error');
    }
  };

  const handleEditSla = (sla) => {
    setSlaForm({
      name: sla.name || '',
      context: sla.context || 'operacional',
      metric: sla.metric || '',
      target: sla.target || '',
      thresholdYellow: sla.thresholdYellow || '',
      thresholdRed: sla.thresholdRed || '',
      periodicity: sla.periodicity || 'Mensual',
      owner: sla.owner || '',
      status: sla.status || 'Activo',
    });
    setEditingSlaId(sla.id);
    setFormDialog({ type: 'sla' });
  };

  const handleDeleteSla = (id) => askDelete('este SLA', () => _doDelete(() => deleteSla(id), 'SLA'));

  const openChangeWorkflowDialog = () => {
    setChangeWorkflowForm(JSON.stringify(changeWorkflow || {}, null, 2));
    setFormDialog({ type: 'changeWorkflow' });
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUserId) {
        const payload = {
          username: userForm.username,
          role: userForm.role,
          active: userForm.active,
          password: userForm.password,
        };
        await updateUser(editingUserId, payload);
        setEditingUserId(null);
        showToast('Usuario actualizado', 'success');
      } else {
        await createUser(userForm);
        showToast('Usuario creado', 'success');
      }
      setUserForm(initialUserForm);
      await loadAll();
      closeFormDialog();
    } catch (err) {
      console.error(err);
      showToast(err.message || 'Error al guardar usuario', 'error');
    }
  };

  const _doDelete = async (fn, label) => {
    setConfirmDel({ open: false, label: '', onConfirm: null });
    try { await fn(); await loadAll(); showToast(`${label} eliminado`, 'success'); }
    catch (err) { console.error(err); showToast(err.message || `Error al eliminar ${label}`, 'error'); }
  };

  const handleDeleteProject   = (id) => askDelete('este proyecto',   () => _doDelete(() => deleteProject(id),    'Proyecto'));
  const handleDeleteProgram   = (id) => askDelete('esta gerencia',   () => _doDelete(() => deleteProgram(id),    'Gerencia'));
  const handleDeleteInitiative= (id) => askDelete('esta iniciativa', () => _doDelete(() => deleteInitiative(id), 'Iniciativa'));
  const handleDeleteRisk      = (id) => askDelete('este riesgo',     () => _doDelete(() => deleteRisk(id),       'Riesgo'));
  const handleDeleteDocument  = (id) => askDelete('este documento',  () => _doDelete(() => deleteDocument(id),   'Documento'));
  const handleDeleteFinance   = (id) => askDelete('este registro financiero', () => _doDelete(() => deleteFinance(id), 'Registro financiero'));
  const handleDeleteApproval  = (id) => askDelete('esta aprobación', () => _doDelete(() => deleteApproval(id),   'Aprobación'));
  const handleDeleteBenefit   = (id) => askDelete('este beneficio',  () => _doDelete(() => deleteBenefit(id),    'Beneficio'));
  const handleDeleteAudit     = (id) => askDelete('esta auditoría',  () => _doDelete(() => deleteAudit(id),      'Auditoría'));
  const handleDeleteIncident  = (id) => askDelete('este incidente',  () => _doDelete(() => deleteIncident(id),   'Incidente'));

  const handleEditDocument = (document) => {
    setDocumentForm({ title: document.title, type: document.type, owner: document.owner, projectId: document.projectId || '' });
    setEditingDocumentId(document.id);
    setFormDialog({ type: 'document' });
  };

  const handleEditFinance = (finance) => {
    setFinanceForm({
      projectId: finance.projectId || '',
      type: finance.type || 'CAPEX',
      approved: finance.approved ?? 0,
      committed: finance.committed ?? 0,
      executed: finance.executed ?? 0,
      forecast: finance.forecast ?? 0,
    });
    setEditingFinanceId(finance.id);
    setFormDialog({ type: 'finance' });
  };

  const handleEditBenefit = (benefit) => {
    setBenefitForm({ projectId: benefit.projectId || '', expected: benefit.expected, realized: benefit.realized, status: benefit.status });
    setEditingBenefitId(benefit.id);
    setFormDialog({ type: 'benefit' });
  };

  const handleEditAudit = (audit) => {
    setAuditForm({ title: audit.title, severity: audit.severity, owner: audit.owner, status: audit.status });
    setEditingAuditId(audit.id);
    setFormDialog({ type: 'audit' });
  };

  const handleEditIncident = (incident) => {
    setIncidentForm({ title: incident.title, severity: incident.severity, description: incident.description, status: incident.status });
    setEditingIncidentId(incident.id);
    setFormDialog({ type: 'incident' });
  };

  const handleEditProject = (project) => {
    setProjectForm({ name: project.name, sponsor: project.sponsor, status: project.status, priority: project.priority, programId: project.programId || '', initiativeId: project.initiativeId || '', startDate: project.startDate || '', endDate: project.endDate || '', progress: project.progress ?? 0 });
    setEditingProjectId(project.id);
    setFormDialog({ type: 'project' });
  };

  const handleEditProgram = (program) => {
    setProgramForm({ name: program.name, sponsor: program.sponsor, objective: program.objective });
    setEditingProgramId(program.id);
    setFormDialog({ type: 'program' });
  };

  const handleEditInitiative = (initiative) => {
    setInitiativeForm({ name: initiative.name, origin: initiative.origin, value: initiative.value, urgency: initiative.urgency });
    setEditingInitiativeId(initiative.id);
    setFormDialog({ type: 'initiative' });
  };

  const handleEditRisk = (risk) => {
    setRiskForm({ title: risk.title, probability: risk.probability, impact: risk.impact, owner: risk.owner });
    setEditingRiskId(risk.id);
    setFormDialog({ type: 'risk' });
  };

  const handleEditApproval = (approval) => {
    setApprovalForm({ requestType: approval.requestType, targetId: approval.targetId || '', targetName: approval.targetName, requestedBy: approval.requestedBy, status: approval.status, comments: approval.comments });
    setEditingApprovalId(approval.id);
    setFormDialog({ type: 'approval' });
  };

  const handleEditUser = (user) => {
    setUserForm({ username: user.username, role: user.role, active: user.active !== false, password: '' });
    setEditingUserId(user.id);
    setFormDialog({ type: 'user' });
  };

  const handleDeleteUser = (user) => askDelete(`al usuario ${user.username}`, () => _doDelete(() => deleteUser(user.id), 'Usuario'));

  const cancelEdit = () => {
    setEditingProjectId(null);
    setEditingProgramId(null);
    setEditingInitiativeId(null);
    setEditingRiskId(null);
    setEditingDocumentId(null);
    setEditingFinanceId(null);
    setEditingDependencyId(null);
    setEditingChangeId(null);
    setEditingApprovalId(null);
    setEditingBenefitId(null);
    setEditingAuditId(null);
    setEditingIncidentId(null);
    setEditingUserId(null);
    setProjectForm(initialProjectForm);
    setProgramForm(initialProgramForm);
    setInitiativeForm(initialInitiativeForm);
    setRiskForm(initialRiskForm);
    setDocumentForm(initialDocumentForm);
    setFinanceForm(initialFinanceForm);
    setDependencyForm(initialDependencyForm);
    setChangeForm(initialChangeForm);
    setApprovalForm(initialApprovalForm);
    setBenefitForm(initialBenefitForm);
    setAuditForm(initialAuditForm);
    setIncidentForm(initialIncidentForm);
    setUserForm(initialUserForm);
    setChangeWorkflowForm(changeWorkflow ? JSON.stringify(changeWorkflow, null, 2) : '');
  };

  const getProgramName = (id) => programs.find((program) => program.id === id)?.name || 'Sin programa';
  const getInitiativeName = (id) => initiatives.find((initiative) => initiative.id === id)?.name || 'Sin iniciativa';

  const projectStatusSummary = projects.reduce(
    (acc, project) => {
      acc[project.status] = (acc[project.status] || 0) + 1;
      return acc;
    },
    {
      Propuesto: 0,
      'En ejecución': 0,
      Completado: 0,
    }
  );

  const highRiskCount = risks.filter((risk) => risk.probability === 'Alta' || risk.impact === 'Alta').length;
  const projectCompletedCount = projectStatusSummary['Completado'];
  const projectInExecutionCount = projectStatusSummary['En ejecución'];
  const programCoverage = programs.filter((program) => projects.some((project) => project.programId === program.id)).length;
  const initiativeCoverage = initiatives.filter((initiative) => projects.some((project) => project.initiativeId === initiative.id)).length;

  const portfolioHealth = highRiskCount >= 3 ? 'Alerta' : highRiskCount >= 1 ? 'Precaución' : 'Saludable';

  const filteredProjects = projects.filter((project) => {
    if (statusFilter && project.status !== statusFilter) return false;
    if (priorityFilter && project.priority !== priorityFilter) return false;
    if (programFilter && project.programId !== programFilter) return false;
    if (initiativeFilter && project.initiativeId !== initiativeFilter) return false;
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      return project.name?.toLowerCase().includes(q) || project.sponsor?.toLowerCase().includes(q);
    }
    return true;
  });

  const searchFilter = (items, fields) => {
    if (!searchQuery) return items;
    const q = searchQuery.toLowerCase();
    return items.filter((item) => fields.some((f) => String(item[f] ?? '').toLowerCase().includes(q)));
  };

  const canAccess = (module, action = 'read') => {
    const permissions = currentUser?.permissions || [];
    return permissions.includes('*:*') || permissions.includes(`${module}:${action}`);
  };

  const drawerWidth = 240;
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { label: 'Dashboard',    icon: <DashboardIcon />,       id: 'section-dashboard' },
    { label: 'Proyectos',    icon: <BusinessIcon />,        id: 'section-projects' },
    { label: 'Gerencias',    icon: <BusinessIcon />,        id: 'section-programs' },
    { label: 'Iniciativas',  icon: <FlagIcon />,            id: 'section-initiatives' },
    { label: 'Riesgos',      icon: <AssignmentIcon />,      id: 'section-risks' },
    { label: 'Documentos',   icon: <DescriptionIcon />,     id: 'section-documents' },
    ...(canAccess('finances', 'read') ? [{ label: 'Finanzas', icon: <MonetizationOnIcon />, id: 'section-finances' }] : []),
    ...(canAccess('dependencies', 'read') ? [{ label: 'Dependencias', icon: <LinkIcon />, id: 'section-dependencies' }] : []),
    ...(canAccess('slas', 'read') ? [{ label: 'SLA', icon: <AccessAlarmIcon />, id: 'section-slas' }] : []),
    { label: 'Aprobaciones', icon: <CheckCircleIcon />,     id: 'section-approvals' },
    { label: 'Beneficios',   icon: <MonetizationOnIcon />,  id: 'section-benefits' },
    { label: 'Auditorías',   icon: <BugReportIcon />,       id: 'section-audits' },
    { label: 'Incidentes',   icon: <BugReportIcon />,       id: 'section-incidents' },
    ...(canAccess('users', 'read') ? [{ label: 'Usuarios', icon: <AccountCircle />, id: 'section-users' }] : []),
    { label: 'Audit Logs',   icon: <HistoryIcon />,         id: 'section-auditlogs' },
  ];

  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!isSmUp) setMobileOpen(false);
  };

  const drawer = (
    <Box sx={{ width: drawerWidth, overflowY: 'auto' }} role="presentation">
      <Box sx={{ px: 2, py: 2.5, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          component="img"
          src="/logo-csm.svg"
          alt="Clínica Santa María"
          sx={{ height: 40, width: 'auto' }}
        />
      </Box>
      <Divider />
      <List sx={{ pt: 1 }}>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              onClick={() => scrollToSection(item.id)}
              sx={{ borderRadius: 2, mx: 0.5, mb: 0.25 }}
            >
              <ListItemIcon sx={{ minWidth: 38 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14 }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  if (authLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Stack spacing={2} alignItems="center">
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">Validando sesión...</Typography>
        </Stack>
      </Box>
    );
  }

  if (!currentUser) {
    return (
      <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardHeader title="Ingreso a Plataforma PPM" subheader="Clínica Santa María" />
          <CardContent>
            <Box component="form" onSubmit={handleLogin} sx={{ display: 'grid', gap: 2 }}>
              <TextField
                label="Usuario"
                value={loginForm.username}
                onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })}
                required
                fullWidth
              />
              <TextField
                label="Contraseña"
                type="password"
                value={loginForm.password}
                onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                required
                fullWidth
              />
              {loginError && (
                <Typography variant="body2" color="error">{loginError}</Typography>
              )}
              <Button variant="contained" type="submit" fullWidth>
                Ingresar
              </Button>
              <Typography variant="caption" color="text.secondary">
                Usuario inicial: admin | Clave inicial: admin123
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {loading && (
        <LinearProgress sx={{ position: 'fixed', top: 72, left: 0, right: 0, zIndex: theme.zIndex.drawer + 2, height: 3 }} />
      )}
      <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ minHeight: 72 }}>
          {!isSmUp && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box
            component="img"
            src="/logo-csm.svg"
            alt="Clínica Santa María"
            sx={{ height: 56, width: 56, borderRadius: 2, mr: 1.5, flexShrink: 0 }}
          />
          <Box sx={{ flexGrow: 1 }} />
          {/* Search bar */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2, px: 1.5, mr: 2 }}>
            <SearchIcon sx={{ fontSize: 18, opacity: 0.8, mr: 0.5 }} />
            <InputBase
              placeholder="Buscar..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ color: 'inherit', fontSize: 14, width: 180 }}
              inputProps={{ 'aria-label': 'buscar' }}
            />
          </Box>
          <Tooltip title={`${approvals.filter(a => a.status === 'Pendiente').length} aprobaciones pendientes, ${incidents.filter(i => i.status === 'Abierto').length} incidentes abiertos`}>
            <IconButton color="inherit">
              <Badge
                badgeContent={(approvals.filter(a => a.status === 'Pendiente').length) + (incidents.filter(i => i.status === 'Abierto').length)}
                color="error"
                max={99}
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton color="inherit">
              <AccountCircle />
            </IconButton>
            <Typography variant="body2" sx={{ display: { xs: 'none', md: 'block' } }}>
              {currentUser.username} ({currentUser.role})
            </Typography>
            <Button color="inherit" variant="outlined" onClick={handleLogout} sx={{ borderColor: 'rgba(255,255,255,0.5)' }}>
              Salir
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
        {isSmUp ? (
          <Drawer
            variant="permanent"
            open
            sx={{
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
              },
            }}
          >
            {drawer}
          </Drawer>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
              },
            }}
          >
            {drawer}
          </Drawer>
        )}
      </Box>
      <Container maxWidth="xl" sx={{ py: 4, mt: '72px', width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
      <Box id="section-dashboard" sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" component="h1" fontWeight={700}>
            Oficina de Proyectos
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Gestión de proyectos, gerencias, iniciativas y riesgos del portafolio.
          </Typography>
        </Box>
        <Chip
          label={portfolioHealth}
          color={portfolioHealth === 'Saludable' ? 'success' : portfolioHealth === 'Precaución' ? 'warning' : 'error'}
          icon={portfolioHealth === 'Alerta' ? <WarningIcon /> : <TrendingUpIcon />}
          sx={{ fontSize: 14, fontWeight: 700, px: 1 }}
        />
      </Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          { label: 'Proyectos', value: projects.length, sub: `${projectStatusSummary['En ejecución']} en ejecución`, color: 'primary.main' },
          { label: 'Gerencias', value: programs.length, sub: `${projects.filter(p => p.programId).length} vinculados`, color: 'secondary.main' },
          { label: 'Iniciativas', value: initiatives.length, sub: `${projects.filter(p => p.initiativeId).length} con proyecto`, color: 'info.main' },
          { label: 'Riesgos', value: risks.length, sub: `${highRiskCount} alto impacto`, color: 'error.main' },
          { label: 'Documentos', value: documents.length, sub: `${projects.filter(p => documents.some(d => d.projectId === p.id)).length} proyectos`, color: 'warning.main' },
          { label: 'Aprobaciones', value: approvals.length, sub: `${approvals.filter(a => a.status === 'Pendiente').length} pendientes`, color: 'success.main' },
          { label: 'Beneficios', value: benefits.length, sub: `${benefits.filter(b => b.status === 'Planificado').length} planificados`, color: 'primary.light' },
          { label: 'Auditorías', value: audits.length, sub: `${audits.filter(a => a.status === 'Abierto').length} abiertas`, color: 'warning.dark' },
          { label: 'Incidentes', value: incidents.length, sub: `${incidents.filter(i => i.status === 'Abierto').length} abiertos`, color: 'error.light' },
        ].map(({ label, value, sub, color }) => (
          <Grid item xs={6} sm={4} md={2} key={label}>
            <Card sx={{ borderTop: 4, borderColor: color, height: '100%' }}>
              <CardContent sx={{ pb: '12px !important' }}>
                <Typography variant="subtitle2" color="text.secondary" noWrap>{label}</Typography>
                <Typography variant="h4" fontWeight={700} color={color}>{value}</Typography>
                <Typography variant="caption" color="text.secondary">{sub}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ─── Form Dialog ───────────────────────────────────────────── */}
      <Dialog open={Boolean(formDialog)} onClose={closeFormDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          {formDialog?.type === 'project'    && (editingProjectId    ? 'Editar proyecto'    : 'Nuevo proyecto')}
          {formDialog?.type === 'program'    && (editingProgramId    ? 'Editar gerencia'    : 'Nueva gerencia')}
          {formDialog?.type === 'initiative' && (editingInitiativeId ? 'Editar iniciativa'  : 'Nueva iniciativa')}
          {formDialog?.type === 'risk'       && (editingRiskId       ? 'Editar riesgo'      : 'Nuevo riesgo')}
          {formDialog?.type === 'document'   && (editingDocumentId   ? 'Editar documento'   : 'Nuevo documento')}
          {formDialog?.type === 'finance'    && (editingFinanceId    ? 'Editar presupuesto'  : 'Nuevo presupuesto')}
          {formDialog?.type === 'dependency' && (editingDependencyId ? 'Editar dependencia'  : 'Nueva dependencia')}
          {formDialog?.type === 'sla'        && (editingSlaId        ? 'Editar SLA'          : 'Nuevo SLA')}
          {formDialog?.type === 'change'     && (editingChangeId     ? 'Editar solicitud de cambio' : 'Nueva solicitud de cambio')}
          {formDialog?.type === 'approval'   && (editingApprovalId   ? 'Editar aprobación'  : 'Nueva aprobación')}
          {formDialog?.type === 'benefit'    && (editingBenefitId    ? 'Editar beneficio'   : 'Nuevo beneficio')}
          {formDialog?.type === 'audit'      && (editingAuditId      ? 'Editar auditoría'   : 'Nueva auditoría')}
          {formDialog?.type === 'incident'   && (editingIncidentId   ? 'Editar incidente'   : 'Nuevo incidente')}
          {formDialog?.type === 'user'       && (editingUserId       ? 'Editar usuario'     : 'Nuevo usuario')}
          {formDialog?.type === 'changeWorkflow' && 'Configuración del workflow de cambios'}
        </DialogTitle>
        <DialogContent dividers>
          {formDialog?.type === 'project' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleProjectSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Nombre" value={projectForm.name} onChange={(e) => setProjectForm({ ...projectForm, name: e.target.value })} required fullWidth />
              <TextField label="Sponsor" value={projectForm.sponsor} onChange={(e) => setProjectForm({ ...projectForm, sponsor: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Gerencia</InputLabel><Select label="Gerencia" value={projectForm.programId} onChange={(e) => setProjectForm({ ...projectForm, programId: e.target.value })}><MenuItem value="">Sin gerencia</MenuItem>{programs.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Iniciativa</InputLabel><Select label="Iniciativa" value={projectForm.initiativeId} onChange={(e) => setProjectForm({ ...projectForm, initiativeId: e.target.value })}><MenuItem value="">Sin iniciativa</MenuItem>{initiatives.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={projectForm.status} onChange={(e) => setProjectForm({ ...projectForm, status: e.target.value })}><MenuItem value="Propuesto">Propuesto</MenuItem><MenuItem value="En ejecución">En ejecución</MenuItem><MenuItem value="Completado">Completado</MenuItem></Select></FormControl>
              <FormControl fullWidth><InputLabel>Prioridad</InputLabel><Select label="Prioridad" value={projectForm.priority} onChange={(e) => setProjectForm({ ...projectForm, priority: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                <TextField label="Fecha inicio" type="date" value={projectForm.startDate || ''} onChange={(e) => setProjectForm({ ...projectForm, startDate: e.target.value })} fullWidth InputLabelProps={{ shrink: true }} />
                <TextField label="Fecha fin" type="date" value={projectForm.endDate || ''} onChange={(e) => setProjectForm({ ...projectForm, endDate: e.target.value })} fullWidth InputLabelProps={{ shrink: true }} />
              </Box>
              <TextField label="Avance (%)" type="number" inputProps={{ min: 0, max: 100 }} value={projectForm.progress ?? 0} onChange={(e) => setProjectForm({ ...projectForm, progress: Number(e.target.value) })} fullWidth />
            </Box>
          )}
          {formDialog?.type === 'program' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleProgramSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Nombre" value={programForm.name} onChange={(e) => setProgramForm({ ...programForm, name: e.target.value })} required fullWidth />
              <TextField label="Sponsor" value={programForm.sponsor} onChange={(e) => setProgramForm({ ...programForm, sponsor: e.target.value })} fullWidth />
              <TextField label="Objetivo" value={programForm.objective} onChange={(e) => setProgramForm({ ...programForm, objective: e.target.value })} fullWidth />
            </Box>
          )}
          {formDialog?.type === 'initiative' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleInitiativeSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Nombre" value={initiativeForm.name} onChange={(e) => setInitiativeForm({ ...initiativeForm, name: e.target.value })} required fullWidth />
              <TextField label="Origen" value={initiativeForm.origin} onChange={(e) => setInitiativeForm({ ...initiativeForm, origin: e.target.value })} fullWidth />
              <TextField label="Valor esperado" value={initiativeForm.value} onChange={(e) => setInitiativeForm({ ...initiativeForm, value: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Urgencia</InputLabel><Select label="Urgencia" value={initiativeForm.urgency} onChange={(e) => setInitiativeForm({ ...initiativeForm, urgency: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'risk' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleRiskSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Título" value={riskForm.title} onChange={(e) => setRiskForm({ ...riskForm, title: e.target.value })} required fullWidth />
              <FormControl fullWidth><InputLabel>Probabilidad</InputLabel><Select label="Probabilidad" value={riskForm.probability} onChange={(e) => setRiskForm({ ...riskForm, probability: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              <FormControl fullWidth><InputLabel>Impacto</InputLabel><Select label="Impacto" value={riskForm.impact} onChange={(e) => setRiskForm({ ...riskForm, impact: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              <TextField label="Dueño" value={riskForm.owner} onChange={(e) => setRiskForm({ ...riskForm, owner: e.target.value })} fullWidth />
            </Box>
          )}
          {formDialog?.type === 'document' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleDocumentSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Título" value={documentForm.title} onChange={(e) => setDocumentForm({ ...documentForm, title: e.target.value })} required fullWidth />
              <TextField label="Tipo" value={documentForm.type} onChange={(e) => setDocumentForm({ ...documentForm, type: e.target.value })} fullWidth />
              <TextField label="Responsable" value={documentForm.owner} onChange={(e) => setDocumentForm({ ...documentForm, owner: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Proyecto</InputLabel><Select label="Proyecto" value={documentForm.projectId} onChange={(e) => setDocumentForm({ ...documentForm, projectId: e.target.value })}><MenuItem value="">Sin proyecto</MenuItem>{projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'finance' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleFinanceSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <FormControl fullWidth><InputLabel>Proyecto</InputLabel><Select label="Proyecto" value={financeForm.projectId} onChange={(e) => setFinanceForm({ ...financeForm, projectId: e.target.value })}><MenuItem value="">Sin proyecto</MenuItem>{projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Tipo</InputLabel><Select label="Tipo" value={financeForm.type} onChange={(e) => setFinanceForm({ ...financeForm, type: e.target.value })}><MenuItem value="CAPEX">CAPEX</MenuItem><MenuItem value="OPEX">OPEX</MenuItem></Select></FormControl>
              <TextField label="Aprobado" type="number" value={financeForm.approved} onChange={(e) => setFinanceForm({ ...financeForm, approved: e.target.value })} fullWidth />
              <TextField label="Comprometido" type="number" value={financeForm.committed} onChange={(e) => setFinanceForm({ ...financeForm, committed: e.target.value })} fullWidth />
              <TextField label="Ejecutado" type="number" value={financeForm.executed} onChange={(e) => setFinanceForm({ ...financeForm, executed: e.target.value })} fullWidth />
              <TextField label="Forecast" type="number" value={financeForm.forecast} onChange={(e) => setFinanceForm({ ...financeForm, forecast: e.target.value })} fullWidth />
            </Box>
          )}
          {formDialog?.type === 'dependency' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleDependencySubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <FormControl fullWidth><InputLabel>Proyecto</InputLabel><Select label="Proyecto" value={dependencyForm.projectId} onChange={(e) => setDependencyForm({ ...dependencyForm, projectId: e.target.value })}><MenuItem value="">Seleccione</MenuItem>{projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Depende de</InputLabel><Select label="Depende de" value={dependencyForm.dependsOnProjectId} onChange={(e) => setDependencyForm({ ...dependencyForm, dependsOnProjectId: e.target.value })}><MenuItem value="">Seleccione</MenuItem>{projects.filter((p) => p.id !== dependencyForm.projectId).map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Tipo</InputLabel><Select label="Tipo" value={dependencyForm.type} onChange={(e) => setDependencyForm({ ...dependencyForm, type: e.target.value })}><MenuItem value="Bloquea">Bloquea</MenuItem><MenuItem value="Depende de">Depende de</MenuItem><MenuItem value="Relacionada">Relacionada</MenuItem></Select></FormControl>
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={dependencyForm.status} onChange={(e) => setDependencyForm({ ...dependencyForm, status: e.target.value })}><MenuItem value="Activa">Activa</MenuItem><MenuItem value="Resuelta">Resuelta</MenuItem></Select></FormControl>
              <TextField label="Responsable" value={dependencyForm.owner} onChange={(e) => setDependencyForm({ ...dependencyForm, owner: e.target.value })} fullWidth />
              <TextField label="Notas" value={dependencyForm.notes} onChange={(e) => setDependencyForm({ ...dependencyForm, notes: e.target.value })} fullWidth multiline rows={3} />
            </Box>
          )}
          {formDialog?.type === 'sla' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleSlaSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Nombre" value={slaForm.name} onChange={(e) => setSlaForm({ ...slaForm, name: e.target.value })} required fullWidth />
              <FormControl fullWidth><InputLabel>Contexto</InputLabel><Select label="Contexto" value={slaForm.context} onChange={(e) => setSlaForm({ ...slaForm, context: e.target.value })}><MenuItem value="negocio">Negocio</MenuItem><MenuItem value="clinico">Clínico</MenuItem><MenuItem value="operacional">Operacional</MenuItem><MenuItem value="tecnologico">Tecnológico</MenuItem></Select></FormControl>
              <TextField label="Métrica" value={slaForm.metric} onChange={(e) => setSlaForm({ ...slaForm, metric: e.target.value })} fullWidth />
              <TextField label="Objetivo" value={slaForm.target} onChange={(e) => setSlaForm({ ...slaForm, target: e.target.value })} fullWidth />
              <TextField label="Umbral amarillo" value={slaForm.thresholdYellow} onChange={(e) => setSlaForm({ ...slaForm, thresholdYellow: e.target.value })} fullWidth />
              <TextField label="Umbral rojo" value={slaForm.thresholdRed} onChange={(e) => setSlaForm({ ...slaForm, thresholdRed: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Periodicidad</InputLabel><Select label="Periodicidad" value={slaForm.periodicity} onChange={(e) => setSlaForm({ ...slaForm, periodicity: e.target.value })}><MenuItem value="Diaria">Diaria</MenuItem><MenuItem value="Semanal">Semanal</MenuItem><MenuItem value="Mensual">Mensual</MenuItem><MenuItem value="Trimestral">Trimestral</MenuItem></Select></FormControl>
              <TextField label="Responsable" value={slaForm.owner} onChange={(e) => setSlaForm({ ...slaForm, owner: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={slaForm.status} onChange={(e) => setSlaForm({ ...slaForm, status: e.target.value })}><MenuItem value="Activo">Activo</MenuItem><MenuItem value="Suspendido">Suspendido</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'change' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleChangeSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Título" value={changeForm.title} onChange={(e) => setChangeForm({ ...changeForm, title: e.target.value })} required fullWidth />
              <FormControl fullWidth><InputLabel>Proyecto</InputLabel><Select label="Proyecto" value={changeForm.projectId} onChange={(e) => setChangeForm({ ...changeForm, projectId: e.target.value })}><MenuItem value="">Sin proyecto</MenuItem>{projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <FormControl fullWidth><InputLabel>Tipo</InputLabel><Select label="Tipo" value={changeForm.type} onChange={(e) => setChangeForm({ ...changeForm, type: e.target.value })}><MenuItem value="Alcance">Alcance</MenuItem><MenuItem value="Plazo">Plazo</MenuItem><MenuItem value="Costo">Costo</MenuItem><MenuItem value="Calidad">Calidad</MenuItem></Select></FormControl>
              <FormControl fullWidth><InputLabel>Impacto</InputLabel><Select label="Impacto" value={changeForm.impact} onChange={(e) => setChangeForm({ ...changeForm, impact: e.target.value })}><MenuItem value="Bajo">Bajo</MenuItem><MenuItem value="Medio">Medio</MenuItem><MenuItem value="Alto">Alto</MenuItem></Select></FormControl>
              <FormControl fullWidth><InputLabel>Prioridad</InputLabel><Select label="Prioridad" value={changeForm.priority} onChange={(e) => setChangeForm({ ...changeForm, priority: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              {editingChangeId && changeWorkflow?.statuses?.length > 0 && (
                <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={changeForm.status || 'Solicitado'} onChange={(e) => setChangeForm({ ...changeForm, status: e.target.value })}>{changeWorkflow.statuses.map((status) => <MenuItem key={status} value={status}>{status}</MenuItem>)}</Select></FormControl>
              )}
              <TextField label="Descripción" value={changeForm.description} onChange={(e) => setChangeForm({ ...changeForm, description: e.target.value })} fullWidth multiline rows={3} />
              <TextField label="Aprobador" value={changeForm.approver} onChange={(e) => setChangeForm({ ...changeForm, approver: e.target.value })} fullWidth />
            </Box>
          )}
          {formDialog?.type === 'approval' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleApprovalSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <FormControl fullWidth><InputLabel>Solicitud</InputLabel><Select label="Solicitud" value={approvalForm.requestType} onChange={(e) => setApprovalForm({ ...approvalForm, requestType: e.target.value })}><MenuItem value="Proyecto">Proyecto</MenuItem><MenuItem value="Gerencia">Gerencia</MenuItem><MenuItem value="Iniciativa">Iniciativa</MenuItem></Select></FormControl>
              <TextField label="Objetivo" value={approvalForm.targetName} onChange={(e) => setApprovalForm({ ...approvalForm, targetName: e.target.value })} fullWidth />
              <TextField label="Solicitado por" value={approvalForm.requestedBy} onChange={(e) => setApprovalForm({ ...approvalForm, requestedBy: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={approvalForm.status} onChange={(e) => setApprovalForm({ ...approvalForm, status: e.target.value })}><MenuItem value="Pendiente">Pendiente</MenuItem><MenuItem value="Aprobado">Aprobado</MenuItem><MenuItem value="Rechazado">Rechazado</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'changeWorkflow' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleSaveChangeWorkflow} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField
                label="Workflow JSON"
                value={changeWorkflowForm}
                onChange={(e) => setChangeWorkflowForm(e.target.value)}
                fullWidth
                multiline
                minRows={12}
                helperText="Debe contener statuses, transitions y escalationDays."
              />
            </Box>
          )}
          {formDialog?.type === 'benefit' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleBenefitSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <FormControl fullWidth><InputLabel>Proyecto</InputLabel><Select label="Proyecto" value={benefitForm.projectId} onChange={(e) => setBenefitForm({ ...benefitForm, projectId: e.target.value })}><MenuItem value="">Sin proyecto</MenuItem>{projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}</Select></FormControl>
              <TextField label="Beneficio esperado" value={benefitForm.expected} onChange={(e) => setBenefitForm({ ...benefitForm, expected: e.target.value })} fullWidth />
              <TextField label="Realizado" value={benefitForm.realized} onChange={(e) => setBenefitForm({ ...benefitForm, realized: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={benefitForm.status} onChange={(e) => setBenefitForm({ ...benefitForm, status: e.target.value })}><MenuItem value="Planificado">Planificado</MenuItem><MenuItem value="En progreso">En progreso</MenuItem><MenuItem value="Realizado">Realizado</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'audit' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleAuditSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Título" value={auditForm.title} onChange={(e) => setAuditForm({ ...auditForm, title: e.target.value })} required fullWidth />
              <FormControl fullWidth><InputLabel>Severidad</InputLabel><Select label="Severidad" value={auditForm.severity} onChange={(e) => setAuditForm({ ...auditForm, severity: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              <TextField label="Responsable" value={auditForm.owner} onChange={(e) => setAuditForm({ ...auditForm, owner: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={auditForm.status} onChange={(e) => setAuditForm({ ...auditForm, status: e.target.value })}><MenuItem value="Abierto">Abierto</MenuItem><MenuItem value="En revisión">En revisión</MenuItem><MenuItem value="Cerrado">Cerrado</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'incident' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleIncidentSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Título" value={incidentForm.title} onChange={(e) => setIncidentForm({ ...incidentForm, title: e.target.value })} required fullWidth />
              <FormControl fullWidth><InputLabel>Severidad</InputLabel><Select label="Severidad" value={incidentForm.severity} onChange={(e) => setIncidentForm({ ...incidentForm, severity: e.target.value })}><MenuItem value="Baja">Baja</MenuItem><MenuItem value="Media">Media</MenuItem><MenuItem value="Alta">Alta</MenuItem></Select></FormControl>
              <TextField label="Descripción" value={incidentForm.description} onChange={(e) => setIncidentForm({ ...incidentForm, description: e.target.value })} fullWidth />
              <FormControl fullWidth><InputLabel>Estado</InputLabel><Select label="Estado" value={incidentForm.status} onChange={(e) => setIncidentForm({ ...incidentForm, status: e.target.value })}><MenuItem value="Abierto">Abierto</MenuItem><MenuItem value="En progreso">En progreso</MenuItem><MenuItem value="Cerrado">Cerrado</MenuItem></Select></FormControl>
            </Box>
          )}
          {formDialog?.type === 'user' && (
            <Box component="form" id="entity-form" noValidate onSubmit={handleUserSubmit} sx={{ display: 'grid', gap: 2, pt: 1 }}>
              <TextField label="Usuario" value={userForm.username} onChange={(e) => setUserForm({ ...userForm, username: e.target.value })} required fullWidth />
              <TextField label={editingUserId ? 'Nueva contraseña (opcional)' : 'Contraseña'} type="password" value={userForm.password} onChange={(e) => setUserForm({ ...userForm, password: e.target.value })} required={!editingUserId} fullWidth />
              <FormControl fullWidth>
                <InputLabel>Rol</InputLabel>
                <Select label="Rol" value={userForm.role} onChange={(e) => setUserForm({ ...userForm, role: e.target.value })}>
                  <MenuItem value="admin">admin</MenuItem>
                  <MenuItem value="pmo">pmo</MenuItem>
                  <MenuItem value="sponsor">sponsor</MenuItem>
                  <MenuItem value="consulta">consulta</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select label="Estado" value={userForm.active ? 'activo' : 'inactivo'} onChange={(e) => setUserForm({ ...userForm, active: e.target.value === 'activo' })}>
                  <MenuItem value="activo">Activo</MenuItem>
                  <MenuItem value="inactivo">Inactivo</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeFormDialog}>Cancelar</Button>
          <Button type="submit" form="entity-form" variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* ─── Delete Confirm Dialog ─────────────────────────────────── */}
      <Dialog open={confirmDel.open} onClose={() => setConfirmDel({ open: false, label: '', onConfirm: null })} maxWidth="xs" fullWidth>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de que deseas eliminar {confirmDel.label}? Esta acción no se puede deshacer.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDel({ open: false, label: '', onConfirm: null })}>Cancelar</Button>
          <Button variant="contained" color="error" onClick={() => confirmDel.onConfirm && confirmDel.onConfirm()}>Eliminar</Button>
        </DialogActions>
      </Dialog>


      <Card id="section-filters" sx={{ mb: 4 }}>
        <CardHeader title="Filtros de proyectos" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  label="Estado"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="Propuesto">Propuesto</MenuItem>
                  <MenuItem value="En ejecución">En ejecución</MenuItem>
                  <MenuItem value="Completado">Completado</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Prioridad</InputLabel>
                <Select
                  label="Prioridad"
                  value={priorityFilter}
                  onChange={(e) => setPriorityFilter(e.target.value)}
                >
                  <MenuItem value="">Todas</MenuItem>
                  <MenuItem value="Baja">Baja</MenuItem>
                  <MenuItem value="Media">Media</MenuItem>
                  <MenuItem value="Alta">Alta</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Gerencia</InputLabel>
                <Select
                  label="Gerencia"
                  value={programFilter}
                  onChange={(e) => setProgramFilter(e.target.value)}
                >
                  <MenuItem value="">Todos</MenuItem>
                  {programs.map((program) => (
                    <MenuItem key={program.id} value={program.id}>{program.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Iniciativa</InputLabel>
                <Select
                  label="Iniciativa"
                  value={initiativeFilter}
                  onChange={(e) => setInitiativeFilter(e.target.value)}
                >
                  <MenuItem value="">Todas</MenuItem>
                  {initiatives.map((initiative) => (
                    <MenuItem key={initiative.id} value={initiative.id}>{initiative.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* ─── Tablero de entidades ─────────────────────────────────── */}
      <Grid id="section-tables" container spacing={3} sx={{ mb: 4 }}>

        {/* Proyectos */}
        <Grid id="section-projects" item xs={12} lg={6}>
          <Card>
            <CardHeader
              title="Proyectos"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(filteredProjects, ['name','status','priority','sponsor'], 'proyectos.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('projects', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('project')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Prioridad</TableCell>
                    <TableCell>Gerencia</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredProjects.map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>
                        <Chip label={item.status} size="small" color={item.status === 'Completado' ? 'success' : item.status === 'En ejecución' ? 'primary' : 'default'} />
                        {item.progress > 0 && <LinearProgress variant="determinate" value={item.progress} sx={{ mt: 0.5, height: 4, borderRadius: 2 }} />}
                      </TableCell>
                      <TableCell><Chip label={item.priority} size="small" color={item.priority === 'Alta' ? 'error' : item.priority === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell>{getProgramName(item.programId)}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('project', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('projects', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditProject(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('projects', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteProject(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Gerencias */}
        <Grid id="section-programs" item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              title="Gerencias"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(programs, ['name', 'sponsor', 'objective']), ['name', 'sponsor', 'objective'], 'programs.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('programs', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('program')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Sponsor</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(programs, ['name','sponsor','objective']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.sponsor}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('program', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('programs', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditProgram(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('programs', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteProgram(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Iniciativas */}
        <Grid id="section-initiatives" item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              title="Iniciativas"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(initiatives, ['name', 'urgency', 'origin']), ['name', 'urgency', 'origin'], 'initiatives.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('initiatives', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('initiative')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Urgencia</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(initiatives, ['name','origin','value']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.name}</TableCell>
                      <TableCell><Chip label={item.urgency} size="small" color={item.urgency === 'Alta' ? 'error' : item.urgency === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('initiative', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('initiatives', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditInitiative(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('initiatives', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteInitiative(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Riesgos */}
        <Grid id="section-risks" item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Riesgos"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(risks, ['title', 'probability', 'impact', 'owner']), ['title', 'probability', 'impact', 'owner'], 'risks.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('risks', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('risk')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Título</TableCell>
                    <TableCell>Prob.</TableCell>
                    <TableCell>Impacto</TableCell>
                    <TableCell>Dueño</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(risks, ['title','owner']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.title}</TableCell>
                      <TableCell><Chip label={item.probability} size="small" color={item.probability === 'Alta' ? 'error' : item.probability === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell><Chip label={item.impact} size="small" color={item.impact === 'Alta' ? 'error' : item.impact === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell>{item.owner}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('risk', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('risks', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditRisk(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('risks', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteRisk(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Documentos */}
        <Grid id="section-documents" item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Documentos"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(documents, ['title', 'type', 'owner']), ['title', 'type', 'owner'], 'documents.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('documents', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('document')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Título</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Responsable</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(documents, ['title','type','owner']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>{item.type}</TableCell>
                      <TableCell>{item.owner}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('document', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('documents', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditDocument(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('documents', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteDocument(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Aprobaciones */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader

              title="Aprobaciones"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(approvals, ['requestType', 'targetName', 'status']), ['requestType', 'targetName', 'status'], 'approvals.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('approvals', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('approval')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Objetivo</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(approvals, ['requestType','targetName','requestedBy']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.requestType}</TableCell>
                      <TableCell>{item.targetName || item.targetId}</TableCell>
                      <TableCell><Chip label={item.status} size="small" color={item.status === 'Aprobado' ? 'success' : item.status === 'Rechazado' ? 'error' : 'warning'} /></TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('approval', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('approvals', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditApproval(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('approvals', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteApproval(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Finanzas */}
        {canAccess('finances', 'read') && (
          <Grid id="section-finances" item xs={12} md={6}>
            <Card>
              <CardHeader
                title="Finanzas"
                subheader={serverStats ? `Aprobado ${Number(serverStats.financeApproved || 0).toLocaleString()} | Ejecutado ${Number(serverStats.financeExecuted || 0).toLocaleString()} | Variación ${Number(serverStats.financeVariance || 0).toLocaleString()}` : 'Control financiero básico'}
                action={
                  <Stack direction="row" spacing={0.5}>
                    {canAccess('finances', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('finance')}><AddIcon /></IconButton></Tooltip>}
                  </Stack>
                }
              />
              <CardContent sx={{ pt: 0 }}>
                <TableContainer sx={{ maxHeight: 280 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Proyecto</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Aprobado</TableCell>
                        <TableCell>Ejecutado</TableCell>
                        <TableCell>Variación</TableCell>
                        <TableCell align="right">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {finances.map((item) => {
                        const variation = (Number(item.executed) || 0) - (Number(item.approved) || 0);
                        return (
                          <TableRow key={item.id} hover>
                            <TableCell>{projects.find((p) => p.id === item.projectId)?.name || '—'}</TableCell>
                            <TableCell>{item.type}</TableCell>
                            <TableCell>{Number(item.approved || 0).toLocaleString()}</TableCell>
                            <TableCell>{Number(item.executed || 0).toLocaleString()}</TableCell>
                            <TableCell>
                              <Chip label={variation.toLocaleString()} size="small" color={variation > 0 ? 'error' : variation < 0 ? 'success' : 'default'} />
                            </TableCell>
                            <TableCell align="right">
                              <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                                <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditFinance(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>
                                {canAccess('finances', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteFinance(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Dependencias */}
        {canAccess('dependencies', 'read') && (
          <Grid id="section-dependencies" item xs={12} md={6}>
            <Card>
              <CardHeader
                title="Dependencias"
                subheader={dependencies.length ? `${dependencies.filter((item) => item.status === 'Activa').length} activas` : 'Relaciones y bloqueos entre proyectos'}
                action={
                  <Stack direction="row" spacing={0.5}>
                    {canAccess('dependencies', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('dependency')}><AddIcon /></IconButton></Tooltip>}
                  </Stack>
                }
              />
              <CardContent sx={{ pt: 0 }}>
                <TableContainer sx={{ maxHeight: 280 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Proyecto</TableCell>
                        <TableCell>Depende de</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell align="right">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dependencies.map((item) => (
                        <TableRow key={item.id} hover>
                          <TableCell>{projects.find((p) => p.id === item.projectId)?.name || '—'}</TableCell>
                          <TableCell>{projects.find((p) => p.id === item.dependsOnProjectId)?.name || '—'}</TableCell>
                          <TableCell>{item.type}</TableCell>
                          <TableCell><Chip label={item.status} size="small" color={item.status === 'Activa' ? 'warning' : 'success'} /></TableCell>
                          <TableCell align="right">
                            <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                              <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('dependency', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                              {canAccess('dependencies', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditDependency(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                              {canAccess('dependencies', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteDependency(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* SLA */}
        {canAccess('slas', 'read') && (
          <Grid id="section-slas" item xs={12} md={6}>
            <Card>
              <CardHeader
                title="SLA"
                subheader={slas.length ? `${slas.filter((item) => item.status === 'Activo').length} activos` : 'Acuerdos y umbrales de servicio'}
                action={
                  <Stack direction="row" spacing={0.5}>
                    {canAccess('slas', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('sla')}><AddIcon /></IconButton></Tooltip>}
                  </Stack>
                }
              />
              <CardContent sx={{ pt: 0 }}>
                <Box sx={{ mb: 2, p: 1.5, border: 1, borderColor: 'divider', borderRadius: 1 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Graficos SLA</Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1.5 }}>
                    <Chip size="small" color="success" label={`Cumple: ${slas.filter((item) => item.complianceStatus === 'Cumple').length}`} />
                    <Chip size="small" color="warning" label={`En riesgo: ${slas.filter((item) => item.complianceStatus === 'En riesgo').length}`} />
                    <Chip size="small" color="error" label={`Incumplido: ${slas.filter((item) => item.complianceStatus === 'Incumplido').length}`} />
                    <Chip size="small" color="default" label={`Sin datos: ${slas.filter((item) => !item.complianceStatus || item.complianceStatus === 'Sin datos').length}`} />
                  </Stack>
                  {slas.length === 0 ? (
                    <Typography variant="caption" color="text.secondary">Crea al menos un SLA para visualizar los graficos de cumplimiento.</Typography>
                  ) : (
                    <Box sx={{ display: 'grid', gap: 0.75 }}>
                      {slas.slice(0, 6).map((item) => {
                        const score = getSlaPerformancePercent(item);
                        return (
                          <Box key={`sla-chart-${item.id}`}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.25 }}>
                              <Typography variant="caption" sx={{ maxWidth: '65%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</Typography>
                              <Typography variant="caption" color="text.secondary">{score === null ? '—' : `${Math.round(score)}%`}</Typography>
                            </Box>
                            <LinearProgress
                              variant={score === null ? 'indeterminate' : 'determinate'}
                              value={score === null ? 0 : score}
                              color={score === null ? 'inherit' : score >= 100 ? 'success' : score >= 80 ? 'warning' : 'error'}
                              sx={{ height: 8, borderRadius: 999 }}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
                <TableContainer sx={{ maxHeight: 280 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Contexto</TableCell>
                        <TableCell>Objetivo</TableCell>
                        <TableCell>Valor actual</TableCell>
                        <TableCell>Cumplimiento</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell align="right">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {slas.map((item) => (
                        <TableRow key={item.id} hover>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.context}</TableCell>
                          <TableCell>{item.target || '—'}</TableCell>
                          <TableCell>{formatSlaCurrentValue(item)}</TableCell>
                          <TableCell><Chip label={item.complianceStatus || 'Sin datos'} size="small" color={slaComplianceColor(item.complianceStatus)} /></TableCell>
                          <TableCell><Chip label={item.status} size="small" color={item.status === 'Activo' ? 'success' : 'default'} /></TableCell>
                          <TableCell align="right">
                            <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                              <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('sla', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                              {canAccess('slas', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditSla(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                              {canAccess('slas', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteSla(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Beneficios */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Beneficios"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(benefits, ['expected', 'status']), ['expected', 'status'], 'benefits.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('benefits', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('benefit')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Beneficio esperado</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Proyecto</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(benefits, ['expected','realized']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.expected}</TableCell>
                      <TableCell><Chip label={item.status} size="small" color={item.status === 'Realizado' ? 'success' : item.status === 'En progreso' ? 'primary' : 'default'} /></TableCell>
                      <TableCell>{projects.find(p => p.id === item.projectId)?.name || '—'}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('benefit', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('benefits', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditBenefit(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('benefits', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteBenefit(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Auditorías */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Auditorías"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(audits, ['title', 'severity', 'status', 'owner']), ['title', 'severity', 'status', 'owner'], 'audits.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('audits', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('audit')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Título</TableCell>
                    <TableCell>Severidad</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Responsable</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(audits, ['title','owner']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.title}</TableCell>
                      <TableCell><Chip label={item.severity} size="small" color={item.severity === 'Alta' ? 'error' : item.severity === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell><Chip label={item.status} size="small" color={item.status === 'Cerrado' ? 'success' : item.status === 'En revisión' ? 'primary' : 'warning'} /></TableCell>
                      <TableCell>{item.owner}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('audit', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('audits', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditAudit(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('audits', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteAudit(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        {/* Incidentes */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Incidentes"
              action={
                <Stack direction="row" spacing={0.5}>
                  <Tooltip title="Exportar CSV"><IconButton size="small" onClick={() => exportCSV(searchFilter(incidents, ['title', 'severity', 'status', 'description']), ['title', 'severity', 'status', 'description'], 'incidents.csv')}><DownloadIcon fontSize="small" /></IconButton></Tooltip>
                  {canAccess('incidents', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('incident')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Título</TableCell>
                    <TableCell>Severidad</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchFilter(incidents, ['title','description']).map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.title}</TableCell>
                      <TableCell><Chip label={item.severity} size="small" color={item.severity === 'Alta' ? 'error' : item.severity === 'Media' ? 'warning' : 'default'} variant="outlined" /></TableCell>
                      <TableCell><Chip label={item.status} size="small" color={item.status === 'Cerrado' ? 'success' : item.status === 'En progreso' ? 'primary' : 'warning'} /></TableCell>
                      <TableCell sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.description}</TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          <Tooltip title="Ver"><IconButton size="small" onClick={() => openDetail('incident', item)}><VisibilityIcon fontSize="small" /></IconButton></Tooltip>
                          {canAccess('incidents', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditIncident(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('incidents', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteIncident(item.id)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

      </Grid>

      {canAccess('users', 'read') && (
        <Grid id="section-users" item xs={12} md={6}>
          <Card>
            <CardHeader
              title="Usuarios"
              action={
                <Stack direction="row" spacing={0.5}>
                  {canAccess('users', 'create') && <Tooltip title="Nuevo"><IconButton size="small" onClick={() => openFormDialog('user')}><AddIcon /></IconButton></Tooltip>}
                </Stack>
              }
            />
            <TableContainer sx={{ maxHeight: 280 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Usuario</TableCell>
                    <TableCell>Rol</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((item) => (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.username}</TableCell>
                      <TableCell><Chip label={item.role} size="small" /></TableCell>
                      <TableCell>
                        <Chip
                          label={item.active !== false ? 'Activo' : 'Inactivo'}
                          size="small"
                          color={item.active !== false ? 'success' : 'default'}
                          variant={item.active !== false ? 'filled' : 'outlined'}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                          {canAccess('users', 'update') && <Tooltip title="Editar"><IconButton size="small" onClick={() => handleEditUser(item)}><EditIcon fontSize="small" /></IconButton></Tooltip>}
                          {canAccess('users', 'delete') && <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => handleDeleteUser(item)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      )}

      <Card id="section-auditlogs" sx={{ mb: 4 }}>
        <CardHeader title="Audit Logs" />
        <CardContent>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
            <FormControl size="small" sx={{ minWidth: 220 }}>
              <InputLabel>Filtrar por entidad</InputLabel>
              <Select
                label="Filtrar por entidad"
                value={auditFilter}
                onChange={(e) => setAuditFilter(e.target.value)}
              >
                <MenuItem value="">Todas</MenuItem>
                {[...new Set(auditLogs.map((l) => l.entityType))].map((t) => (
                  <MenuItem key={t} value={t}>{t}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button variant="outlined" onClick={loadAll}>Refrescar</Button>
          </Stack>
          <TableContainer component={Paper} sx={{ maxHeight: 320 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Timestamp</TableCell>
                  <TableCell>Entidad</TableCell>
                  <TableCell>Acción</TableCell>
                  <TableCell>Usuario</TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Cambios</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {auditLogs.filter((l) => (auditFilter ? l.entityType === auditFilter : true)).map((log) => (
                  <TableRow
                    key={log.id}
                    hover
                    sx={{ cursor: 'pointer' }}
                    onClick={async () => {
                      try {
                        const entity = await fetchEntity(log.entityType, log.entityId);
                        if (entity) openDetail(log.entityType, entity);
                        else openDetail('auditLog', { id: log.id, timestamp: log.timestamp, entityType: log.entityType, action: log.action, user: log.user, entityId: log.entityId, changes: log.changes });
                      } catch (e) {
                        console.error('Error fetching entity for log', e);
                        openDetail('auditLog', { id: log.id, timestamp: log.timestamp, entityType: log.entityType, action: log.action, user: log.user, entityId: log.entityId, changes: log.changes });
                      }
                    }}
                  >
                    <TableCell>{new Date(log.timestamp).toLocaleString()}</TableCell>
                    <TableCell>{log.entityType}</TableCell>
                    <TableCell>{log.action}</TableCell>
                    <TableCell>{log.user}</TableCell>
                    <TableCell>{log.entityId}</TableCell>
                    <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{JSON.stringify(log.changes)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {detailView && (
        <DetailsPanel
          type={detailView.type}
          item={detailView.item}
          onClose={closeDetail}
          onSave={handleSaveDetail}
          projects={projects}
          programs={programs}
          initiatives={initiatives}
          showToast={showToast}
        />
      )}
      <Toast toasts={toasts} removeToast={removeToast} />
    </Container>
  </Box>
  );
}

export default App;
